import module from 'nominas/finiquitos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class NominasFiniquitosAgregarComponent {
  onClose
  colaborador
  proyecto
  proyectos = null
  colaboradores = null
  data = {
    descripcion: '',
  }

  constructor ($state, NominasFiniquitos, NominasFiniquitosProyectos, NominasFiniquitosProyectoColaboradores, $filter) {
    this.$state = $state
    this.NominasFiniquitos = NominasFiniquitos
    this.NominasFiniquitosProyectos = NominasFiniquitosProyectos
    this.NominasFiniquitosProyectoColaboradores = NominasFiniquitosProyectoColaboradores
    this.$filter = $filter
  }

  $onInit () {
    this.getProyectos()
  }

  aceptar () {
    this.procesando = true

    return this.NominasFiniquitos.post(this.proyecto.id, this.colaborador.id, this.data)
      .then((response) => {
        this.$state.go('nominas.finiquito.escenarios', {
          id_proyecto: response.data.proyecto.id,
          id_colaborador: response.data.colaborador.id,
          id_finiquito: response.data.finiquito.id,
        })
      })
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    this.onClose({$event: {}})
  }

  getProyectos () {
    this.loading = true
    this.proyectos = null

    return this.NominasFiniquitosProyectos.get()
      .then((response) => (this.proyectos = orderBy(response.data, ['descripcion'])))
      .finally(() => (this.loading = false))
  }

  getColaboradores () {
    this.loading = true
    this.colaboradores = null

    return this.NominasFiniquitosProyectoColaboradores.get(this.proyecto.id)
      .then((response) => (this.colaboradores = orderBy(response.data, ['descripcion'])))
      .finally(() => (this.loading = false))
  }
}

module.component('nominasFiniquitosAgregar', {
  controller: NominasFiniquitosAgregarComponent,
  template,
  bindings: {
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquitos/components/agregar/component.js